// @ts-nocheck
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { CartResult, UpdateCartApiParameter } from "@insite/client-framework/Services/CartService";
import {
    DispatchBeginPlaceOrderForApproval,
    DispatchCompletePlaceOrderForApproval,
    DispatchResetOrders,
    DispatchResetQuotes,
    ExecuteOnSuccessCallback,
    PopulateApiParameter,
    ReloadCurrentCart,
    UpdateCart,
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrderForApproval";

type HandlerType = ApiHandlerDiscreteParameter<
    { poNumber?: string } & HasOnSuccess<string>,
    UpdateCartApiParameter,
    CartResult
>;

// taken from toolkit/src/Extensions/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrderForApproval.ts - types didn't match so We had to copy it
export const SetCartNotes: HandlerType = props => {
    if (props.apiParameter.cart && !props.apiParameter.cart.notes) {
        props.apiParameter.cart.notes = props.getState().pages.checkoutShipping.editedCartNotes ?? "";
    }
};
const PopulatePoNumber: HandlerType = ({ parameter: { poNumber }, apiParameter }) => {
    if (poNumber && apiParameter.cart) {
        apiParameter.cart.poNumber = poNumber;
    }
};

export const SetAuthorizedPickUpPerson: HandlerType = props => {
    if (!props.apiParameter.cart) {
        return;
    }

    const { authorizedPickUpPerson, isApplicable } = props.getState().bunzl.pages.checkoutReviewAndSubmit;
    props.apiParameter.cart.properties = {
        ...props.apiParameter.cart.properties,
        authorizedPickUpPerson: isApplicable ? authorizedPickUpPerson.trim() : "",
    };
};

export const chain = [
    DispatchBeginPlaceOrderForApproval,
    PopulateApiParameter,
    SetCartNotes,
    PopulatePoNumber,
    SetAuthorizedPickUpPerson,
    UpdateCart,
    ReloadCurrentCart,
    ExecuteOnSuccessCallback,
    DispatchCompletePlaceOrderForApproval,
    DispatchResetOrders,
    DispatchResetQuotes,
];

const placeOrderForApprovalWithOptionalPoNumber = createHandlerChainRunner(
    chain,
    "PlaceOrderForApprovalWithOptionalPoNumber",
);

export default placeOrderForApprovalWithOptionalPoNumber;
